import { useEffect, useState } from "react";
import { navLinks, site } from "@/mocks/chiagua";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-200))]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-community-line text-lg" aria-hidden="true"></i>
          </span>
          <span
            className="font-heading text-2xl text-foreground-950"
            style={{ letterSpacing: "0.5px" }}
          >
            {site.brand}
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200 hover:text-foreground-950 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-quill-pen-line" aria-hidden="true"></i>
            投稿吃瓜
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full bg-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="mx-4 mb-4 rounded-2xl bg-background-50 p-2 shadow-[0_10px_30px_-12px_oklch(var(--foreground-950)/0.25)] lg:hidden"
          aria-label="移动端导航"
        >
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={() => setOpen(false)}
              className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-background-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-2 block rounded-xl bg-primary-500 px-4 py-3 text-center text-sm font-bold text-background-50"
          >
            投稿吃瓜
          </a>
        </nav>
      )}
    </header>
  );
}